var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillJobMaxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H15.5V20H0.5V0ZM14.25 18.75V1.25H1.75V18.75H14.25ZM13 5V6.25H8V5H13ZM13 10V11.25H8V10H13ZM13 15V16.25H8V15H13ZM7.18945 4.18945L4.875 6.50391L3.18555 4.81445L4.06445 3.93555L4.875 4.74609L6.31055 3.31055L7.18945 4.18945ZM7.18945 9.18945L4.875 11.5039L3.18555 9.81445L4.06445 8.93555L4.875 9.74609L6.31055 8.31055L7.18945 9.18945ZM7.18945 14.1895L4.875 16.5039L3.18555 14.8145L4.06445 13.9355L4.875 14.7461L6.31055 13.3105L7.18945 14.1895Z",
    fill: "#D12232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillJobMaxIcon);
export default __webpack_public_path__ + "static/media/skill_jobMaxIcon.4e98a8e556f05f8692d0c945185b2e4d.svg";
export { ForwardRef as ReactComponent };